import { useCallback, useEffect, useState } from 'react';
import { getDashboardState } from './cabinet.api';
import { DashboardState } from './cabinet.schemas';

const emptyDashboardState: DashboardState = {
  subInfo: null,
  devices: [],
  devicesTotal: 0,
  userState: null,
  trialStatus: null,
};

export function useDashboardState(enabled: boolean) {
  const [dashboardState, setDashboardState] = useState<DashboardState>(emptyDashboardState);
  const [isLoading, setIsLoading] = useState(enabled);
  const [hasLoaded, setHasLoaded] = useState(false);

  const refreshDashboard = useCallback(async () => {
    if (!enabled) {
      return;
    }

    setIsLoading(true);

    try {
      const nextState = await getDashboardState();
      setDashboardState(nextState);
    } finally {
      setHasLoaded(true);
      setIsLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    refreshDashboard();
  }, [refreshDashboard]);

  useEffect(() => {
    window.addEventListener('mifvpn:refresh', refreshDashboard);
    return () => window.removeEventListener('mifvpn:refresh', refreshDashboard);
  }, [refreshDashboard]);

  return {
    dashboardState,
    hasLoaded,
    isLoading,
    refreshDashboard,
    setDashboardState,
  };
}
